import React, { useCallback } from "react";
import { useState, useEffect } from 'react'
import { supabase } from "../supabaseClient";
import AppNavBar from '../components/AppNavBar'
import { Container, Nav, Tab, Card, Stack } from "react-bootstrap";
import IconField from '../components/IconField';
import { useLocation } from "react-router-dom";
import PhonebookTab from '../components/PhonebookTab';

function Tabulations(props) {
    const location = useLocation();
    console.log("Location state :");
    console.log(location);
    let profileid = null;
    let etablissementid = null;
    if(location && location.state !== undefined) {
        profileid = location.state?.profileid;
        etablissementid = location.state?.etablissementid;
    } 
    const [loading, setLoading] = useState(false)
    const [tabulations, setTabulations] = useState(null);
    // const [totalSize, setTotalSize] = useState(0);
    // const [sizePerPage, setSizePerPage] = useState(10);
    // const [page, setPage] = useState(1);

    /**
         * Get the size of the profile table when the table is updated
         */
    // const getTotalSize = useCallback( async () => {
    //     //Get total size
    //     if (etablissementid !== undefined) {
    //         setLoading(true)
    //         console.log("(Tabulations) Get total Size of phonebook in db with profile " + profileid + " and etablissement " + etablissementid)
    //         let { data, error, count } = await supabase.from('tabulations')
    //             .select('*,phonebook_profiles!inner(*)', { count: 'exact', head: true })
    //             .eq('phonebook_profiles.id', profileid)
    //         console.log("Total size = " + count + " - " + data + " - " + error);
    //         if (error) {
    //             console.warn(error)
    //         } else if (data) {
    //             console.log(data);
    //         }
    //        // setTotalSize(count);
    //         console.log("Total size = " + count);
    //         setLoading(false);
    //     } else {
    //         console.log("Error in gettabulations - profile " + profileid);
    //     }

    // }, [profileid, etablissementid]);

    /**
         * Get the phonebook table from the database with pagination
         * @param {*} firstIndex 
         * @param {*} lastIndex 
         */
//    const gettabulations = useCallback(async (firstIndex, lastIndex) => {
    const gettabulations = useCallback(async () => {
        

        //Get the total size of the profile table for pagination
        //getTotalSize();

        setLoading(true)
        console.log("(Tabulations)Get phonebook in db with profile " + profileid);
        if (etablissementid !== undefined) {
            let { data, error } = await supabase
                .from('tabulations')
                .select('*,phonebook_profiles!inner(*)')
                .eq('phonebook_profiles.id', profileid)
                // .order('ordre', { ascending: true })
                //.range(firstIndex, lastIndex)

            if (error) {
                console.warn(error)
            } else if (data) {
                //console.log(data);
                data.map((item, index) => { item["num"] =  index + 1; return item; });
                setTabulations(data);
                console.log("Row for tabulations:");
                console.log(data);
            }
        } else {
            console.log("Error in getGlobalPhonebook - etablissement " + etablissementid + " is undefined");
        }

        setLoading(false);
    }, [etablissementid, profileid ]);

    const updateTablePage = useCallback(() => {
 //       const currentIndex = (page - 1) * sizePerPage;
//        gettabulations(currentIndex, currentIndex + sizePerPage - 1);
        gettabulations();
    }, [gettabulations]);

    useEffect(() => {
        updateTablePage();
    }, [etablissementid, updateTablePage]);

    return (
        <>
            <AppNavBar />
            <Container >
                {loading && <div>Loading...</div>}
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Nav variant="pills" className="flex-row">
                        {tabulations?.map((tabulation, index) => {
                            return (
                                <Nav.Item>
                                    <Nav.Link eventKey={tabulation.dbstring}>
                                        <Stack col-md-5 mx-auto>
                                            <div className="main">
                                                <div className="tabelement" ><IconField iconname={tabulation.iconname} icontype={tabulation.icontype} color={'#a35ba5'} /></div>
                                                <div className="tabelement" >{tabulation.title}</div>
                                            </div>
                                        </Stack>
                                    </Nav.Link>
                                </Nav.Item>
                            )
                        })}
                    </Nav>
                    <Tab.Content>
                        {tabulations?.map((tabulation, index) => {
                            return (
                                <Tab.Pane eventKey={tabulation.dbstring}>
                                    <Card>
                                    <PhonebookTab TabulationId={tabulation.id} />
                                    </Card>
                                </Tab.Pane>
                            )
                        })}
                    </Tab.Content>
                </Tab.Container>

</Container>

        </>

    );
};

export default Tabulations;